"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_intl_1 = require("react-intl");

var defaultLocale = 'ru';
var locale = defaultLocale;
exports.intlConfig = new react_intl_1.IntlProvider({
  messages: null,
  locale: locale,
  defaultLocale: defaultLocale
}).getChildContext().intl;